module.exports = __webpack_public_path__ + "img/artillery-wagon-base-12.15dc39df.png";